export const AppRoles = {
  AGENTE_FINANCEIRO: 'AGENTE_FINANCEIRO',
  AGENTE_FINANCEIRO_PERFIL: 'AGENTE_FINANCEIRO_PERFIL',
  USUARIO_AGENTE_FINANCEIRO: 'USUARIO_AGENTE_FINANCEIRO',
  AGENTE_OFICIAL: 'AGENTE_OFICIAL',
  CONFIG_PERFIL: 'CONFIG_PERFIL',
  CONFIG_USUARIO: 'CONFIG_USUARIO',
  DETRAN: 'DETRAN',
  ESPECIE_VEICULO: 'ESPECIE_VEICULO',
  GESTAO: 'GESTAO',
  GUINCHO: 'GUINCHO',
  MARCA_MODELO: 'MARCA_MODELO',
  MUNICIPIO: 'MUNICIPIO',
  PARAMETRO: 'PARAMETRO',
  PATIO: 'PATIO',
  REGISTRO_GARANTIA_READ: 'REGISTRO_GARANTIA_READ',
  TIPO_PRODUTO: 'TIPO_PRODUTO',
  WRITE_REGISTRO_GARANTIA: 'REGISTRO_GARANTIA_WRITE',
} as const;